var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntwurf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.167,
    height: 28.76,
    viewBox: "0 0 21.167 28.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    d: "M16.427,87.146H26.16",
    transform: "translate(-11.71 -74.054)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    d: "M16.427,87.146H26.16",
    transform: "translate(-11.71 -69.835)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    d: "M16.427,87.146H26.16",
    transform: "translate(-11.71 -65.616)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M1.227,104.813V78.054h13.9l5.263,6.028v20.731Z",
    transform: "translate(-1.227 -78.054)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    d: "M24.191,78.054v6.873h6.7",
    transform: "translate(-11.724 -78.054)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntwurf);
export default __webpack_public_path__ + "static/media/entwurf.56c70e756c5397a15301264f40026269.svg";
export { ForwardRef as ReactComponent };